import { Storage } from 'aws-amplify';

export async function uploadFile(file: File) {
  const fileType = file.name.split('.').pop();
  const result = await Storage.put(`${crypto.randomUUID()}.${fileType}`, file);
  return result.key;
}
